var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 754,
    height: 377,
    viewBox: "0 0 754 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 565.026,
    cy: -0.233856,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.535,
    cy: -102.731,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.505,
    cy: 171.771,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 405.682,
    cy: -186.385,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.961,
    cy: 140.15,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 558.424,
    cy: -49.6667,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.186,
    cy: -57.6621,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 495.94,
    cy: 145.572,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 355.82,
    cy: -187.489,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.198,
    cy: 168.2,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 539.083,
    cy: -95.6362,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.406,
    cy: -8.56958,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 530.015,
    cy: 109.157,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 307.418,
    cy: -175.471,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.349,
    cy: 184.449,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 508.364,
    cy: -134.921,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.815,
    cy: 41.1071,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 553.342,
    cy: 65.077,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 263.862,
    cy: -151.176,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 389.113,
    cy: 187.758,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.408,
    cy: -164.768,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.094,
    cy: 87.8871,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 564.289,
    cy: 16.421,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.213,
    cy: -116.304,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 437.998,
    cy: 177.894,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.02,
    cy: -183.087,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.046,
    cy: 128.493,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 562.082,
    cy: -33.402,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.968,
    cy: -73.2994,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 482.582,
    cy: 155.549,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.639,
    cy: 160.079,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.884,
    cy: -80.9009,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.878,
    cy: -25.1754,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 519.745,
    cy: 122.289,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 323.18,
    cy: -180.903,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 323.171,
    cy: 180.432,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 519.753,
    cy: -122.748,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.878,
    cy: 24.6964,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.877,
    cy: 80.4436,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.647,
    cy: -160.552,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 372.446,
    cy: 188.126,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 482.594,
    cy: -156.01,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.964,
    cy: 72.8213,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 562.082,
    cy: 32.9454,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.054,
    cy: -128.969,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.013,
    cy: 182.622,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 438.009,
    cy: -178.358,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.205,
    cy: 115.827,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 564.289,
    cy: -16.8774,
    r: 186.522,
    stroke: "#D183E6",
    strokeOpacity: 0.05,
    strokeWidth: 3.76812
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/ellipse.103c1887800ff22fcb02327a4beec75b.svg";
export { ForwardRef as ReactComponent };